import type { ReactNode } from 'react';
import { useFela } from 'react-fela';

import { Logo } from '@/modules/ui';

import { logoWrapper, menu, menuContent } from './MenuDesktop.rules';

export interface MenuDesktopProps {
    children: ReactNode;
}

export const MenuDesktop = ({ children }: MenuDesktopProps) => {
    const { css } = useFela();

    return (
        <div className={css(menu)}>
            <div className={css(menuContent)}>
                <div className={css(logoWrapper)}>
                    <Logo />
                </div>
                {children}
            </div>
        </div>
    );
};
